import { ChartFrequency, IComposableChartsWidget } from 'wisestep-api';

import NewCandidateBarGraphPostgres from '../../../../../features/composableAnalytics/BaseCharts/newCandidate/postgres/NewCandidateBarGraphPostgres';
import NewCandidateMetricChartPostgres from '../../../../../features/composableAnalytics/BaseCharts/newCandidate/postgres/NewCandidateMetricChartPostgres';
import NewCandidateTablePostgres from '../../../../../features/composableAnalytics/BaseCharts/newCandidate/postgres/NewCandidateTablePostgres';
import { ChartScope } from '../../../../../features/composableAnalytics/types';
import { getChartFreqForTimePeriod, NewCandidateWidget } from '../../helper';

export const newCandidateWidgetsByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Record<NewCandidateWidget, IComposableChartsWidget> => {
  const defaultQuery = {
    category: 'new_candidate',
    filters: [],
    type: 'count-metric',
    range: timePeriodId,
    scope,
    frequency,
  };

  const widgetConfig: Record<NewCandidateWidget, IComposableChartsWidget> = {
    [NewCandidateWidget.COUNT_METRIC]: {
      name: 'Total New Candidates',
      filters: {},
      category: 'new_candidate',
      type: `metric_new_candidate_total_${timePeriodId}_${scope}_postgre`,
      component: (
        <NewCandidateMetricChartPostgres
          query={{
            ...defaultQuery,
            type: 'count-metric',
          }}
          title="Total New Candidates"
          widgetName={NewCandidateWidget.COUNT_METRIC}
        />
      ),
    },
    [NewCandidateWidget.CANDIDATE_RECRUITER_TABLE]: {
      name: `New Candidates by Recruiters`,
      filters: {},
      category: 'new_candidate',
      type: `table_new_candidate_recruiter_${timePeriodId}_${scope}_${frequency}_postgre`,
      component: (
        <NewCandidateTablePostgres
          query={{
            ...defaultQuery,
            type: 'candidate-recruiter-table',
          }}
          title={`New Candidates by Recruiters`}
          widgetName={NewCandidateWidget.CANDIDATE_RECRUITER_TABLE}
          widgetType={`table_new_candidate_recruiter_${timePeriodId}_${scope}_${frequency}_postgre`}
        />
      ),
    },
    [NewCandidateWidget.CANDIDATE_SOURCE_TABLE]: {
      name: 'New Candidates by Source',
      filters: {},
      category: 'new_candidate',
      type: `table_new_candidate_source_${timePeriodId}_${scope}_postgre`,
      component: (
        <NewCandidateTablePostgres
          query={{
            ...defaultQuery,
            type: 'candidate-source-table',
          }}
          title="New Candidates by Source"
          widgetName={NewCandidateWidget.CANDIDATE_SOURCE_TABLE}
          widgetType={`table_new_candidate_source_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [NewCandidateWidget.CANDIDATE_DOWNLOAD_SOURCE_TABLE]: {
      name: 'New Candidates by Download Source',
      filters: {},
      category: 'new_candidate',
      type: `table_new_candidate_download_source_${timePeriodId}_${scope}_postgre`,
      component: (
        <NewCandidateTablePostgres
          query={{
            ...defaultQuery,
            type: 'candidate-download-source-table',
          }}
          title="New Candidates by Download Source"
          widgetName={NewCandidateWidget.CANDIDATE_DOWNLOAD_SOURCE_TABLE}
          widgetType={`table_new_candidate_download_source_${timePeriodId}_${scope}_postgre`}
        />
      ),
    },
    [NewCandidateWidget.CANDIDATE_BAR_GRAPH]: {
      name: 'New Candidates - Trends',
      filters: {},
      category: 'new_candidate',
      type: `barchart_new_candidate_trends_${timePeriodId}_${scope}_postgre`,
      component: (
        <NewCandidateBarGraphPostgres
          query={{
            ...defaultQuery,
            type: 'candidate-bar-graph',
          }}
          title="New Candidates - Trends"
          widgetName={NewCandidateWidget.CANDIDATE_BAR_GRAPH}
        />
      ),
    },
  };
  return widgetConfig;
};
